import { render, staticRenderFns } from "./ui-info-right-block-delivery.vue?vue&type=template&id=58dd336e&scoped=true&"
import script from "./ui-info-right-block-delivery.vue?vue&type=script&lang=js&"
export * from "./ui-info-right-block-delivery.vue?vue&type=script&lang=js&"
import style0 from "./ui-info-right-block-delivery.vue?vue&type=style&index=0&id=58dd336e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd336e",
  null
  
)

export default component.exports